import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes.js";
import CreditWallet from "views/admin/Dashboard/CreditWallet";
import OfferIndividual from "views/admin/Dashboard/OfferIndividual";
import CreateOffer from "views/admin/Dashboard/CreateOffer";
import EnitityListWithCoupon from "views/admin/Dashboard/EnitityListWithCoupon";
import OpenOrdersIndividual from "views/admin/OpenOrders/OpenOrdersIndividual";
import Subcategories from "views/admin/Dashboard/NewCategory/Subcategories";
import DurgsIndividualpage from "views/admin/Partners/DurgsIndividualpage";
import OtcProductIndividualpage from "views/admin/Partners/OtcProductIndividualpage";
import PetcareIndividualpage from "views/admin/PetCare/PetcareIndividualpage";
import UserActivity from "views/admin/UserDetails/variables/UserActivity";
import RequestedLocalities from "views/admin/Dashboard/RequestedLocalities";
import PharmacyInventory from "views/admin/PharmacyDetails/PharmacyInventory";
import PharmacyDetail from "views/admin/PharmacyDetail";
import PharmacyPartners from "views/admin/PharmacyPartners";
import DeliveryPartners from "views/admin/DeliveryPartners";
import DeliveryPartner from "views/admin/DeliveryPartner";

export default function Admin(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Main Dashboard");

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  const getActiveRoute = (routes) => {
    let activeRoute = "Main Dashboard";
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name);
      }
    }
    return activeRoute;
  };
  // const getActiveNavbar = (routes) => {
  //   let activeNavbar = false;
  //   for (let i = 0; i < routes.length; i++) {
  //     if (
  //       window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
  //     ) {
  //       return routes[i].secondary;
  //     }
  //   }
  //   return activeNavbar;
  // };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      {/* Navbar & Main Content */}
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        {/* Main Content */}
        <main
          className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]`}
        >
          {/* Routes */}
          <div className="h-full">
            {/* <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={"Horizon UI Tailwind React"}
              brandText={currentRoute}
              secondary={getActiveNavbar(routes)}
              {...rest}
            /> */}
            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
              <Routes>
                {getRoutes(routes)}

                <Route path="add-wallet-amount" element={<CreditWallet />} />
                <Route path="create-offer" element={<CreateOffer />} />
                <Route path="offer-details/:id" element={<OfferIndividual />} />
                <Route
                  path="entity-list/:id"
                  element={<EnitityListWithCoupon />}
                />
                <Route
                  path="open-order/:id"
                  element={<OpenOrdersIndividual />}
                />
                <Route
                  path="order/individual/:id"
                  element={<OpenOrdersIndividual />}
                />
                <Route path="sub-categories/:id" element={<Subcategories />} />
                <Route
                  path="pharmacy-inventory/:pharmacyId"
                  element={<PharmacyInventory />}
                />
                {/* Per-pharmacy console. Registered here rather than in
                    routes.js because routes.js drives the sidebar, and a
                    detail page has no sidebar entry. */}
                <Route
                  path="pharmacy/:pharmacyId"
                  element={<PharmacyDetail />}
                />
                {/* The two paths the pharmacy directory used to live at,
                    before "Pharmacy Partner" and "Pharmacy Details" were
                    merged into one screen. Both are bookmarked, and the
                    console's back button points at the second — so they render
                    the merged page rather than 404ing to the dashboard. They
                    are here, not in routes.js, so the sidebar shows one entry
                    for the one screen. */}
                <Route path="saleForce" element={<PharmacyPartners />} />
                <Route path="pharmacy-details" element={<PharmacyPartners />} />

                {/* Per-partner console. Same reasoning as the pharmacy one:
                    registered here rather than in routes.js because routes.js
                    drives the sidebar and a detail page has no entry. */}
                <Route
                  path="delivery-partner/:partnerId"
                  element={<DeliveryPartner />}
                />
                {/* The two paths the delivery directory used to live at,
                    before "Delivery Boys Location" and "Delivery Partner
                    Details" were merged. Both are bookmarked, so they render
                    the merged page rather than 404ing to the dashboard. */}
                <Route path="delivery-list" element={<DeliveryPartners />} />
                <Route
                  path="delivery-partner-details"
                  element={<DeliveryPartners />}
                />
                <Route
                  path="durgs-individual-page/:id"
                  element={<DurgsIndividualpage />}
                />
                <Route
                  path="otc-product-individual-page/:id"
                  element={<OtcProductIndividualpage />}
                />
                <Route
                  path="pet-care-medicine-list/:id"
                  element={<PetcareIndividualpage />}
                />
                <Route
                  path="user-activity/:id"
                  element={<UserActivity />}
                />
                <Route path='requested-localities' element={<RequestedLocalities />} />
                {/* UserActivity */}
                <Route path="*" element={<Navigate to="/admin/dashboard" />} />
              </Routes>
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
